/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Err_Remap_RequiredInputs */

const en_sch_err_remap_required = /** @type {(inputs: Sch_Err_Remap_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items are still in this status. Choose where they go.`)
};

const de_sch_err_remap_required = /** @type {(inputs: Sch_Err_Remap_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es liegen noch Vorgänge in diesem Status. Wähle, wohin sie wandern.`)
};

/**
* | output |
* | --- |
* | "Items are still in this status. Choose where they go." |
*
* @param {Sch_Err_Remap_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_remap_required = /** @type {((inputs?: Sch_Err_Remap_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Remap_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_remap_required(inputs)
	return en_sch_err_remap_required(inputs)
});